import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import PersonServiceLegacy from "../../services/PersonService";
// @ts-expect-error - TS2739 - Type '{ personId: string; affiliationId: string; fullName: string; firstName: string; lastName: string; initialsBackgroundColorHex: string; emailAddress: string; smallPhotoUrl: string; phoneNumber: string; studentId: string; id: string; label: string; }' is missing the following properties from type 'PersonLite': secondaryEmailAddress, lastActiveDate
const convertPersonToPersonModel = (person) => ({
    personId: person.personId,
    affiliationId: person.affiliationId,
    fullName: person.fullName,
    firstName: person.firstName,
    lastName: person.lastName,
    initialsBackgroundColorHex: person.initialsBackgroundColorHex,
    emailAddress: person.emailAddress,
    smallPhotoUrl: person.smallPhotoUrl,
    phoneNumber: "",
    studentId: person.studentId,
    id: person.personId,
    label: "",
});
const PersonLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        valueKey: "id",
        valueRenderer: function valueRenderer(person) {
            return (_jsxs("span", { children: [person.firstName, " ", person.lastName] }));
        },
        optionRenderer: function optionRenderer(person) {
            return (_jsxs("span", { children: [person.firstName, " ", person.lastName, " (", person.studentId, ")"] }));
        },
        fetchItemsById: (ids) => {
            return PersonServiceLegacy.findAllByIds(ids).then((results) => results.map(convertPersonToPersonModel));
        },
        fetchOptions: (search) => {
            return PersonServiceLegacy.listAsJson(search).then((results) => results.map(convertPersonToPersonModel));
        },
    });
};
export default PersonLookup;
